import { render } from "./SelectLocale.vue?vue&type=template&id=4cd9a8c8"
import script from "./SelectLocale.vue?vue&type=script&lang=js"
export * from "./SelectLocale.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__